"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TourTimesAndDistancesBlock = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _mapping = require("@nicbase/mapping");

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseReducers = require("nicbase-reducers");

var _nicbaseTranslation = require("nicbase-translation");

var _constants = require("../../constants");

var _tourDuration = _interopRequireDefault(require("./tour-duration"));

var _tourMileage = _interopRequireDefault(require("./tour-mileage"));

require("./tour-times-block.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var TourTimesAndDistancesBlock = function TourTimesAndDistancesBlock(_ref) {
  var tour = _ref.tour,
      latestData = _ref.latestData;
  var scheduledStartTime = tour.scheduledStartTime,
      scheduledEndTime = tour.scheduledEndTime,
      realEndTime = tour.realEndTime,
      realStartTime = tour.realStartTime,
      wayPoints = tour.wayPoints,
      assetType = tour.assetType;
  var endWaypoint = (0, _react.useMemo)(function () {
    return wayPoints.find(function (waypoint) {
      return waypoint.type === _constants.WAYPOINT_TYPES.END;
    });
  }, [wayPoints]);
  var startWaypoint = (0, _react.useMemo)(function () {
    return wayPoints.find(function (waypoint) {
      return waypoint.type === _constants.WAYPOINT_TYPES.START;
    });
  }, [wayPoints]);
  var user = (0, _nicbaseReducers.useUser)();
  var startTimestamp;
  var startTranslationKey = '';

  if (realStartTime) {
    startTimestamp = realStartTime;
    startTranslationKey = 'widgets.tourBoard.infoBlock.realStartTime';
  } else if (scheduledStartTime) {
    startTimestamp = scheduledStartTime;
    startTranslationKey = 'widgets.tourBoard.infoBlock.plannedStartTime';
  } else if (startWaypoint && startWaypoint.plannedStartTime) {
    startTimestamp = startWaypoint.plannedStartTime;
    startTranslationKey = 'widgets.tourBoard.infoBlock.plannedStartTime';
  } else {
    startTimestamp = null;
    startTranslationKey = 'widgets.tourBoard.infoBlock.noInformationAvailable';
  }

  var displayETA = false;
  var endTimestamp;
  var endTranslationKey = '';

  if (realEndTime) {
    endTimestamp = realEndTime;
    endTranslationKey = 'widgets.tourBoard.infoBlock.realEndTime';
  } else if (endWaypoint && endWaypoint.estimatedTimeOfArrival) {
    endTimestamp = endWaypoint.estimatedTimeOfArrival;
    displayETA = true;
    endTranslationKey = 'widgets.tourBoard.infoBlock.calculatedEndTime';
  } else if (endWaypoint && endWaypoint.scheduledTimeOfArrival) {
    endTimestamp = endWaypoint.scheduledTimeOfArrival;
    endTranslationKey = 'widgets.tourBoard.infoBlock.plannedEndTime';
  } else if (scheduledEndTime) {
    endTimestamp = scheduledEndTime;
    endTranslationKey = 'widgets.tourBoard.infoBlock.plannedEndTime';
  } else {
    endTimestamp = null;
    endTranslationKey = 'widgets.tourBoard.infoBlock.noInformationAvailable';
  }

  var tourDuration;

  if (tour.status === _constants.TOUR_STATUS.RUNNING) {
    tourDuration = Date.now() - new Date(realStartTime).getTime();
  }

  if (tour.status === _constants.TOUR_STATUS.FINISHED) {
    tourDuration = new Date(tour.realEndTime) - new Date(realStartTime).getTime();
  }

  var offlineLimit = (0, _mapping.isRailAsset)(assetType) ? _constants.ASSET_OFFLINE_LIMIT_RAIL : _constants.ASSET_OFFLINE_LIMIT;
  var isDataCurrent = !(latestData !== null && latestData !== void 0 && latestData.common.date) ? Date.now() - new Date(realStartTime).getTime() < offlineLimit : Date.now() - new Date(latestData.common.date).getTime() < offlineLimit;
  var isAssetOfflineFinishedTours = tour.status === _constants.TOUR_STATUS.FINISHED && !tour.realEndTime;
  var isAssetOfflineRunningTours = tour.status === _constants.TOUR_STATUS.RUNNING && !isDataCurrent && !displayETA;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "times-and-distance-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "tour-times-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "start-time-container ".concat(startTimestamp ? '' : 'no-info')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "time"
  }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedDate, {
    value: startTimestamp,
    hour: "numeric",
    minute: "numeric",
    timeZone: user.timezone
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "date"
  }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedDate, {
    value: startTimestamp,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    timeZone: user.timezone
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "description"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: startTranslationKey,
    tagName: "span"
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "arrow"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.ArrowRight, {
    className: "inline-block"
  })), isAssetOfflineFinishedTours || isAssetOfflineRunningTours ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "asset-offline-container"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.assetOffline"
  }, function (text) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "asset-offline"
    }, text);
  })) : /*#__PURE__*/_react["default"].createElement("div", {
    className: "end-time-container ".concat(endTimestamp ? '' : 'no-info')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "time"
  }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedDate, {
    value: endTimestamp,
    hour: "numeric",
    minute: "numeric",
    timeZone: user.timezone
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "date"
  }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedDate, {
    value: endTimestamp,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    timeZone: user.timezone
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "description"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: endTranslationKey,
    tagName: "span"
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "tour-running-statistics-container"
  }, /*#__PURE__*/_react["default"].createElement(_tourMileage["default"], {
    mileageCalculations: tour.mileageCalculations,
    status: tour.status,
    lengthUnit: user.lengthUnit
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "distance"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Distance, {
    className: "inline-block"
  })), /*#__PURE__*/_react["default"].createElement(_tourDuration["default"], {
    duration: tourDuration,
    status: tour.status
  })));
};

exports.TourTimesAndDistancesBlock = TourTimesAndDistancesBlock;
TourTimesAndDistancesBlock.propTypes = {
  tour: _propTypes["default"].shape({
    assetId: _propTypes["default"].number,
    assetType: _propTypes["default"].number,
    mileageCalculations: _propTypes["default"].shape({
      recommended: _propTypes["default"].shape({
        value: _propTypes["default"].number,
        type: _propTypes["default"].string
      }),
      available: _propTypes["default"].arrayOf(_propTypes["default"].shape({
        value: _propTypes["default"].number,
        type: _propTypes["default"].string
      }))
    }),
    id: _propTypes["default"].string,
    status: _propTypes["default"].string,
    scheduledStartTime: _propTypes["default"].string,
    scheduledEndTime: _propTypes["default"].string,
    realEndTime: _propTypes["default"].string,
    realStartTime: _propTypes["default"].string,
    wayPoints: _propTypes["default"].arrayOf(_propTypes["default"].shape({}))
  }).isRequired,
  latestData: _propTypes["default"].shape({
    common: _propTypes["default"].shape({
      date: _propTypes["default"].string
    })
  })
};
TourTimesAndDistancesBlock.defaultProps = {
  latestData: {
    common: {
      date: null
    }
  }
};
var _default = TourTimesAndDistancesBlock;
exports["default"] = _default;